import { State } from "../../core/src/states/State";
import UIController from "../../core/src/ui/UIController";
import { UIStates } from "../../core/src/ui/UIStates";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import ViewManager from "../../core/src/utils/ViewManager";
import ErrorModel from  "../../core/src/model/ErrorModel";
import ReelGroup from "../../core/src/views/ReelGroup";
import Configs from "../vendorConfigs/Configs";
import * as FEIM from "@rlx/feim";

export default class ErrorState extends State {

    private errorMap:{[key: string]: string} = {};

    private softErrorCodes: number[] = [];
    private fatalErrorCodes: number[] = [];

    public async enter(): Promise<void> {

        super.enter();
        const errorConfig = Configs.error;

        if (errorConfig.hasErrorMap()) {
            this.errorMap = errorConfig.getErrorMap();
        }

        if (errorConfig.hasSoftErrorCodes()) {
            this.softErrorCodes = errorConfig.getSoftErrorCodes();
        }

        if (errorConfig.hasFatalErrorCodes()) {
            this.fatalErrorCodes = errorConfig.getFatalErrorCodes();
        }
        
        let errCodeFormat = Number(ErrorModel.errorCode);
        let softError = true;

        this.fatalErrorCodes.forEach( excludeCode => {
            if(excludeCode === errCodeFormat) {
                softError = false;
            }
        });

        ViewManager.getLayer("SplashOverlay").setScene("open");
        UIController.setState(UIStates.ERROR);

        if(softError) {  // non fatal error
            this.showError();
        } else {  // fatal error
            await this.showError();
            FEIM.send.exitGame();
        }
    }

    private showError() {
        return new Promise<void>(resolve => {
            CommandManager.execute(Commands.SHOW_ERROR, () => {
                this.exit();
                resolve();
            });
        });
        
    }

    public exit(): void {
        ErrorModel.cleanUp();
        ViewManager.getLayer("SplashOverlay").clear();
        ReelGroup.instance?.stopDefault();
        CommandManager.execute(Commands.STOP_AUTOPLAY);
        super.exit();
    }
}